import Moralis from 'moralis';
import Metamask from './WalletIcons/metamaskWallet.png';
import Coin98 from './WalletIcons/Coin98.png';
import WalletConnect from './WalletIcons/wallet-connect.svg';
import MathWallet from './WalletIcons/MathWallet.svg';
import TokenPocket from './WalletIcons/TokenPocket.svg';
import SafePal from './WalletIcons/SafePal.svg';
import TrustWallet from './WalletIcons/TrustWallet.png';

interface Connector {
  title: string;
  icon: string;
  connectorId?: Moralis.Web3ProviderType;
  priority: number;
}

export const connectors: Connector[] = [
  {
    title: 'Metamask',
    icon: Metamask,
    priority: 1,
  },
  {
    title: 'WalletConnect',
    icon: WalletConnect,
    connectorId: 'walletconnect',
    priority: 2,
  },
  {
    title: 'Trust Wallet',
    icon: TrustWallet,
    priority: 3,
  },
  {
    title: 'MathWallet',
    icon: MathWallet,
    priority: 999,
  },
  {
    title: 'TokenPocket',
    icon: TokenPocket,
    priority: 999,
  },
  {
    title: 'SafePal',
    icon: SafePal,
    priority: 999,
  },
  {
    title: 'Coin98',
    icon: Coin98,
    priority: 999,
  },
];
